import { render, staticRenderFns } from "./ProductsRecommendedModal.vue?vue&type=template&id=60b277d4&scoped=true&"
import script from "./ProductsRecommendedModal.vue?vue&type=script&lang=js&"
export * from "./ProductsRecommendedModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductsRecommendedModal.vue?vue&type=style&index=0&id=60b277d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b277d4",
  null
  
)

export default component.exports